import styled from 'styled-components';
import { mixins, styles } from '4all-ui/styles';

export const SearchResultStatusLabelContainer = styled.div`
  height: 40px;
  background-color: ${({ bgColor }) => bgColor || 'transparent'};
  font-family: 'Open Sans';
  font-size: 12px;
  font-weight: 600;
  text-align: left;
  color: ${({ color }) => color || '#FFF'};
  border-bottom: ${({ bgColor, borderColor }) => {
    let color = null;

    if (!bgColor) {
      color = styles.colors.GRAY_LIGHT_2;
    }

    if (borderColor) {
      color = borderColor;
    }

    if (color) {
      return `1px solid ${color}`;
    }

    return 'none';
  }};
  line-height: 33px;
  padding: 0px 20px;
  ${mixins.flexPosition({ align: 'center', justify: 'space-between' })}
`;

export const StatusText = styled.p`
  margin: 0;
`;

export const QtdFiltered = styled.p`
  margin: 0;
`;



// WEBPACK FOOTER //
// ./src/components/OrderStatusLabel/style.js